import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as clientAcion from "../../store/Y2xpZW50Vmlza/actions"
import PropTypes from "prop-types"
import moment from "moment"
//import classnames from "classnames"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { MultiSelect } from "react-multi-select-component"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"
import ReactDOM from 'react-dom'
import SalesTableComponent from "./SalesTableComponent"
import ProcessTableComponent from "./ProcessTableComponent"
import SubTableComponent from "./SubTableComponent"
import BranchTabComponent from "./BranchTabComponent"

const ClientVisitReport = (props) => {
  const { searchBtnStyle, dispatch } = props
  const title = "Client Visit Report"

  let tabs = [
    {
      id: 1,
      value: "salesUrge",
      label: "Sales Urge",
    },
    {
      id: 2,
      value: "processStatus",
      label: "Process Status",
    },
    {
      id: 3,
      value: "subStatus",
      label: "Sub Status",
    },
  ]

  const [customIconActiveTab, setCustomIconActiveTab] = useState(1)

  //Count section
  const [counterData, setCounterData] = useState(false)
  const [valueData, setValueData] = useState(false)
  const [totalMode, setTotalMode] = useState("")

  const [loading, setLoading] = useState(false)
  //process status count section

  const [counterProcessData, setCounterProcessData] = useState(false)
  const [valueProcessData, setValueProcessData] = useState(false)
  const [totalProcessMode, setTotalProcessMode] = useState("")

  //sub status count section
  const [counterSubData, setCounterSubData] = useState(false)
  const [valueSubData, setValueSubData] = useState(false)
  const [totalSubMode, setTotalSubMode] = useState("")




  //Fetching API
  useEffect(() => {
    setValueData(true)
    setValueProcessData(true)
    setValueSubData(true)
    setType({ label: "Employee", value: "employee" })
    dispatch(clientAcion.loadRecordsMetaData())
    dispatch(clientAcion.loadClientVisit({ mode: 1 }))
  }, [])
  //validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  //date format
  const update = useSelector((specificstate) => specificstate.clientVisitReport)

  const { client_data = [], recordsMetaData = {}, branchClient_data = [] } = update
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  // salesurge portion data
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [salesProcessAgent, setSalesProcessAgent] = useState([])
  const [salesSubAgent, setSalesSubAgent] = useState([])
  // const [salesUrge, setSalesUrge] = useState([])
  const [source, setSource] = useState([])

  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )
  const handleCompany = (e) => {
    setCompany(e)
    setBranch([])
  }
  //Handle Change

  const [salesUrgeData, setSalesUrgeData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })

  const handleChange = (e) => {
    setSalesUrgeData({ ...salesUrgeData, [e.target.name]: e.target.value })
  }
  //handle filter
  //setType
  const [type, setType] = useState([])

  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const branches = !isEmpty(branch) && branch.map((m) => m.value)
  const salesAgents = !isEmpty(salesAgent) && salesAgent.map((m) => m.value)
  const salesProcessAgents =
    !isEmpty(salesProcessAgent) && salesProcessAgent.map((m) => m.value)
  const salesSubAgents =
    !isEmpty(salesSubAgent) && salesSubAgent.map((m) => m.value)
  const [renderPage, setRenderPage] = useState(false)

  const [searchValue, setSearchValue] = useState({})
  const [isBranchData, setIsBranchData] = useState(false)

  const handleFilter = (e) => {
    e.preventDefault()

    const formValid = simpleValidator.current.allValid()


    var searchBranch = !isEmpty(branch) ? branches : ""
    var searchCompany = company && company.value
    var searchSource = source && source.value
    var searchFromDate =
      salesUrgeData && salesUrgeData.eventFromDate
        ? moment(salesUrgeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      salesUrgeData && salesUrgeData.eventToDate
        ? moment(salesUrgeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchSalesAgent =
      customIconActiveTab == 1
        ? salesAgents
        : customIconActiveTab == 2
          ? salesProcessAgents
          : customIconActiveTab == 3
            ? salesSubAgents
            : ""
    var searchType = !isEmpty(type) ? type.value : ""
    var searchvalue = {}
    searchvalue.mode = customIconActiveTab
    if (searchFromDate) {
      searchvalue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.visitToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSalesAgent) {
      searchvalue.salesAgentId = searchSalesAgent
    }
    if (searchType) {
      searchvalue.type = searchType
    }
    var branchSearchValue = {}
    branchSearchValue.mode = customIconActiveTab
    if (searchFromDate) {
      branchSearchValue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      branchSearchValue.visitToDate = searchToDate
    }
    if (searchBranch) {
      branchSearchValue.branchId = searchBranch
    }
    if (searchCompany) {
      branchSearchValue.companyId = searchCompany
    }
    if (searchSource) {
      branchSearchValue.leadSourceId = searchSource
    }
    if (type.value == "branch") {
      if (!formValid) {
        simpleValidator.current.showMessages()
        setRenderPage(!renderPage)
        forceUpdate(1)
      } else {
        setIsBranchData(true)
        setSearchValue(branchSearchValue)
        dispatch(clientAcion.loadBranchClientVisit(branchSearchValue))
        setBtnLoader(true)
        setTimeout(() => {
          setBtnLoader(false)
        }, 3000)
      }
    } else {
      setSearchValue(searchvalue)
      setIsBranchData(false)
      dispatch(clientAcion.loadClientVisit(searchvalue))
      setBtnLoader(true)
      setTimeout(() => {
        setBtnLoader(false)
      }, 3000)
    }


  }

  //salesurge table data  isBranchData == true

  const salesUrgeTable =
    !isEmpty(isBranchData == true ? branchClient_data : client_data)
      ? (isBranchData == true ? branchClient_data : client_data).map((data, index) => {
        const hotCount =
          !isEmpty(data.salesUrgeCount)
            ? parseInt(data.salesUrgeCount.Hot)
            : 0
        const hotValue =
          !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.HotBudget
            ? parseInt(data.salesUrgeCount.HotBudget)
            : 0

        const warmCount =
          !isEmpty(data.salesUrgeCount)
            ? parseInt(data.salesUrgeCount.Warm)
            : 0
        const warmValue =
          !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.WarmBudget
            ? parseInt(data.salesUrgeCount.WarmBudget)
            : 0

        const coldCount =
          !isEmpty(data.salesUrgeCount)
            ? parseInt(data.salesUrgeCount.Cold)
            : 0
        const coldValue =
          !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.ColdBudget
            ? parseInt(data.salesUrgeCount.ColdBudget)
            : 0

        const totalCount =
          !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.Total
            ? parseInt(data.salesUrgeCount.Total)
            : 0
        const totalValue =
          !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.TotalBudget
            ? parseInt(data.salesUrgeCount.TotalBudget)
            : 0
        const salesEmployeeId = recordsMetaData && !isEmpty(recordsMetaData.employeeOptions) ?
          recordsMetaData.employeeOptions.find(m => m.name
            == data.salesAgentName) && recordsMetaData.employeeOptions.find(m => m.name
              == data.salesAgentName).value : ""
        console.log(salesEmployeeId, "salesEmpid")
        return {
          sNo: index + 1,
          salesAgentName: data.salesAgentName ? data.salesAgentName : "--",
          branchName: data.branchName ? data.branchName : "--",
          branchId: data.branchId ? data.branchId : "--",
          hot: totalMode == "Count" ? hotCount : hotValue,
          warm: totalMode == "Count" ? warmCount : warmValue,
          cold: totalMode == "Count" ? coldCount : coldValue,
          total: totalMode == "Count" ? totalCount : totalValue,
          salesEmployee: salesEmployeeId
        }
      })
      : []



  const handleClickTab = (tableData) => {
    console.log("sales calling")
    const statusName = tableData.status
    const salesEmpId = isBranchData == false ? tableData.empId : ""
    const countDetails = {
      mode: tableData.mode,
      menuMode: tableData.menuMode,
      salesEmpId: salesEmpId
    }


    if (searchValue.visitFromDate) {
      countDetails.visitFromDate = searchValue.visitFromDate
    }
    if (searchValue.visitToDate) {
      countDetails.visitToDate = searchValue.visitToDate
    }
    if (searchValue.companyId) {
      countDetails.companyId = searchValue.companyId
    }
    if (searchValue.branchId) {
      countDetails.branchId = searchValue.branchId
    }
    if (searchValue.leadSourceId) {
      countDetails.leadSourceId = searchValue.leadSourceId
    }

    api
      .post(`/get_client_visit_detail_report`, countDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect
          console.log("statusData in setTimeout:", statusData)
          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <SalesTableComponent
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={countDetails}
                name={statusName}
                dateFormat={dateFormat}
              />,
              container
            )
            newTab.document.title = 'CLIENT-VISIT-REPORT'
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)

      })
  }
  //branch based tab 

  const handleBranchTab = (tableData) => {
    console.log("branch list calling true")
    const statusName = tableData.status
    const excel = tableData.mode == 1 ? "SalesUrge.csv" : tableData.mode == 2 ? "ProcessStatus.csv" : "SubStatus.csv"
    const branchCountDetails = {
      mode: tableData.mode,
      menuMode: tableData.menuMode,
      branchId: tableData.branchId
    }


    if (searchValue.visitFromDate) {
      branchCountDetails.visitFromDate = searchValue.visitFromDate
    }
    if (searchValue.visitToDate) {
      branchCountDetails.visitToDate = searchValue.visitToDate
    }
    if (searchValue.companyId) {
      branchCountDetails.companyId = searchValue.companyId
    }

    if (searchValue.leadSourceId) {
      branchCountDetails.leadSourceId = searchValue.leadSourceId
    }


    api
      .post(`/get_client_visit_value_report_branch`, branchCountDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect
          console.log("statusData in setTimeout:", statusData)
          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <BranchTabComponent
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={branchCountDetails}
                name={statusName}
                dateFormat={dateFormat}
                excelName={excel}
              />,
              container
            )
            newTab.document.title = 'CLIENT-VISIT-REPORT'
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)

      })
  }
  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      footer: "",
    },
    {
      dataField: "salesAgentName",
      text: "Sales Agent Name",
      csvExport: false,
      hidden: isBranchData == true ? true : false,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      csvExport: false,
      hidden: isBranchData == true ? false : true,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "hot",
      text: "Hot",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 1,
          menuMode: "hot",
          status: "HOT",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: "bold"

            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleClickTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      }
      ,
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "warm",
      text: "Warm",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 1,
          menuMode: "warm",
          status: "WARM",
          empId: row.salesEmployee,
          branchId: row.branchId

        }
        return (
          <div
            style={{
              fontWeight: "bold"

            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleClickTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "cold",
      text: "Cold",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 1,
          menuMode: "cold",
          status: "COLD",
          empId: row.salesEmployee,
          branchId: row.branchId

        }
        return (
          <div
            style={{
              fontWeight: "bold"

            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleClickTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "total",
      text: "Total",
      headerStyle: {
        minWidth: "160px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
  ]

  // process status portion salceUrgeCount salceUrgeCount 0

  const processStatusTable =
    !isEmpty(isBranchData == true ? branchClient_data : client_data)
      ? (isBranchData == true ? branchClient_data : client_data).map((data, index) => {
        const assignedCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Assigned
            ? parseInt(data.salceUrgeCount.Assigned)
            : 0
        const assignedValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.AssignedBudget
            ? parseInt(data.salceUrgeCount.AssignedBudget)
            : 0

        const followUpCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Followup
            ? parseInt(data.salceUrgeCount.Followup)
            : 0
        const followUpValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.FollowupBudget
            ? parseInt(data.salceUrgeCount.FollowupBudget)
            : 0
        const QuotationCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.QuotationCreated
            ? parseInt(data.salceUrgeCount.QuotationCreated)
            : 0
        const QuotationValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.QuotationCreatedBudget
            ? parseInt(data.salceUrgeCount.QuotationCreatedBudget)
            : 0

        const QuoteSendCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QuoteSent
            ? parseInt(data.salceUrgeCount.QuoteSent)
            : 0
        const QuoteSentValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QuoteSentBudget
            ? parseInt(data.salceUrgeCount.QuoteSentBudget)
            : 0
        const qcSentCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QcRequestSent
            ? parseInt(data.salceUrgeCount.QcRequestSent)
            : 0
        const qcSentValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.QcRequestSentBudget
            ? parseInt(data.salceUrgeCount.QcRequestSentBudget)
            : 0

        const qcApproveCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QcApproveQuote
            ? parseInt(data.salceUrgeCount.QcApproveQuote)
            : 0
        const qcApproveValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.QcApproveQuoteBudget
            ? parseInt(data.salceUrgeCount.QcApproveQuoteBudget)
            : 0

        const qcRecheckCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QcRecheckQuote
            ? parseInt(data.salceUrgeCount.QcRecheckQuote)
            : 0
        const qcRecheckValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.QcRecheckQuoteBudget
            ? parseInt(data.salceUrgeCount.QcRecheckQuoteBudget)
            : 0
        const bookingCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.BookingComplete
            ? parseInt(data.salceUrgeCount.BookingComplete)
            : 0
        const bookingValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.BookingCompleteBudget
            ? parseInt(data.salceUrgeCount.BookingCompleteBudget)
            : 0

        const rejectedCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Rejected
            ? parseInt(data.salceUrgeCount.Rejected)
            : 0
        const rejectedValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.RejectedBudget
            ? parseInt(data.salceUrgeCount.RejectedBudget)
            : 0

        const requestForCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.RequestForQuoteAlteration
            ? parseInt(data.salceUrgeCount.RequestForQuoteAlteration)
            : 0
        const requestForValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.RequestForQuoteAlterationBudget
            ? parseInt(data.salceUrgeCount.RequestForQuoteAlterationBudget)
            : 0
        const quoteApproachCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.AlterQuoteApproach
            ? parseInt(data.salceUrgeCount.AlterQuoteApproach)
            : 0
        const quoteApproachValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.AlterQuoteApproachBudget
            ? parseInt(data.salceUrgeCount.AlterQuoteApproachBudget)
            : 0

        const quoteRecheckCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.AlterQuoteRecheck
            ? parseInt(data.salceUrgeCount.AlterQuoteRecheck)
            : 0
        const quoteRecheckValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.AlterQuoteRecheckBudget
            ? parseInt(data.salceUrgeCount.AlterQuoteRecheckBudget)
            : 0
        const totalCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Total
            ? parseInt(data.salceUrgeCount.Total)
            : 0
        const totalValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.TotalBudget
            ? parseInt(data.salceUrgeCount.TotalBudget)
            : 0
        const salesEmployeeId = recordsMetaData && !isEmpty(recordsMetaData.employeeOptions) ?
          recordsMetaData.employeeOptions.find(m => m.name
            == data.salesAgentName) && recordsMetaData.employeeOptions.find(m => m.name
              == data.salesAgentName).value : ""
        return {
          key: index,
          sNo: index + 1,
          salesAgentName: data.salesAgentName ? data.salesAgentName : "--",
          branchName: data.branchName ? data.branchName : "--",
          branchId: data.branchId ? data.branchId : "--",
          assigned:
            totalProcessMode == "Count" ? assignedCount : assignedValue,
          followUp:
            totalProcessMode == "Count" ? followUpCount : followUpValue,
          QuotationCreated:
            totalProcessMode == "Count" ? QuotationCount : QuotationValue,
          QuoteSent:
            totalProcessMode == "Count" ? QuoteSendCount : QuoteSentValue,
          QcRequestSent:
            totalProcessMode == "Count" ? qcSentCount : qcSentValue,
          QcApproveQuote:
            totalProcessMode == "Count" ? qcApproveCount : qcApproveValue,
          QcRecheckQuote:
            totalProcessMode == "Count" ? qcRecheckCount : qcRecheckValue,
          BookingComplete:
            totalProcessMode == "Count" ? bookingCount : bookingValue,
          Rejected:
            totalProcessMode == "Count" ? rejectedCount : rejectedValue,
          RequestForQuoteAlteration:
            totalProcessMode == "Count" ? requestForCount : requestForValue,
          AlterQuoteApproach:
            totalProcessMode == "Count"
              ? quoteApproachCount
              : quoteApproachValue,
          AlterQuoteRecheck:
            totalProcessMode == "Count"
              ? quoteRecheckCount
              : quoteRecheckValue,
          salesEmployee: salesEmployeeId,
          total: totalProcessMode == "Count" ? totalCount : totalValue,
        }
      })
      : []
  //TAB   <ProcessTableComponent
  const handleProcessTab = (tableData) => {

    const statusName = tableData.status
    const salesEmpId = isBranchData == false ? tableData.empId : ""
    const countDetails = {
      mode: tableData.mode,
      menuMode: tableData.menuMode,
      salesEmpId: salesEmpId
    }


    if (searchValue.visitFromDate) {
      countDetails.visitFromDate = searchValue.visitFromDate
    }
    if (searchValue.visitToDate) {
      countDetails.visitToDate = searchValue.visitToDate
    }
    if (searchValue.companyId) {
      countDetails.companyId = searchValue.companyId
    }
    if (searchValue.branchId) {
      countDetails.branchId = searchValue.branchId
    }
    if (searchValue.leadSourceId) {
      countDetails.leadSourceId = searchValue.leadSourceId
    }

    api
      .post(`/get_client_visit_detail_report`, countDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect
          console.log("statusData in setTimeout:", statusData)
          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <ProcessTableComponent
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={countDetails}
                name={statusName}
                dateFormat={dateFormat}
              />,
              container
            )
            newTab.document.title = 'CLIENT-VISIT-REPORT'
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)

      })
  }
  //table columns
  const processColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      footer: "",
    },
    {
      dataField: "salesAgentName",
      text: "Sales Agent Name",
      hidden: isBranchData == true ? true : false,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      csvExport: false,
      hidden: isBranchData == true ? false : true,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "assigned",
      text: "Assigned",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "Assigned",
          status: "Assigned",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "followUp",
      text: "Followup",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "followup",
          status: "Followup",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "QuotationCreated",
      text: "Quotation Created / Quote Sent",
      headerStyle: {
        minWidth: "235px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "quotationCreated",
          status: "Quotation Created / Quote Sent",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "QcRequestSent",
      text: "Qc Request Sent",
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "QCRequestSent",
          status: "Qc Request Sent",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "QcApproveQuote",
      text: "Qc Approve Quote",
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "QCApprovedQuote",
          status: "Qc Approve Quote",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "QcRecheckQuote",
      text: "Qc  Recheck Quote",
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "QCRecheckQuote,",
          status: "Qc  Recheck Quote",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "BookingComplete",
      text: "Booking Complete",
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "bookingComplete",
          status: "Booking Complete",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "Rejected",
      text: "Rejected",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "rejected",
          status: "Rejected",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "RequestForQuoteAlteration",
      text: "Request For Quote Alteration",
      headerStyle: {
        minWidth: "230px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "requestForQuoteAlteration",
          status: "Request For Quote Alteration",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "AlterQuoteApproach",
      text: "Alter Quote Approach",
      headerStyle: {
        minWidth: "190px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "AlterQuoteApproach",
          status: "Alter Quote Approach",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "AlterQuoteRecheck",
      text: "Alter Quote Recheck",
      headerStyle: {
        minWidth: "190px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 2,
          menuMode: "AlterQuoteRecheck",
          status: "Alter Quote Recheck",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold'
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleProcessTab(tableData)
              }
            }}

          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "total",
      text: "Total",
      headerStyle: {
        minWidth: "150px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
  ]

  //sub status portion tab

  const subStatusTable =
    !isEmpty(isBranchData == true ? branchClient_data : client_data)
      ? (isBranchData == true ? branchClient_data : client_data).map((data, index) => {
        const openCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Open
            ? parseInt(data.salceUrgeCount.Open)
            : 0
        const openValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.OpenBudget
            ? parseInt(data.salceUrgeCount.OpenBudget)
            : 0
        const almostCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.AlmostConfirm
            ? parseInt(data.salceUrgeCount.AlmostConfirm)
            : 0
        const almostValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount.AlmostConfirmBudget
            ? parseInt(data.salceUrgeCount.AlmostConfirmBudget)
            : 0

        const bookedCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Booked
            ? parseInt(data.salceUrgeCount.Booked)
            : 0
        const bookedValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.BookedBudget
            ? parseInt(data.salceUrgeCount.BookedBudget)
            : 0
        const followUpCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Followup
            ? parseInt(data.salceUrgeCount.Followup)
            : 0
        const followUpValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.FollowupBudget
            ? parseInt(data.salceUrgeCount.FollowupBudget)
            : 0
        const needTimeToThinkCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NeedTimeToThink"]
            ? parseInt(data.salceUrgeCount["NeedTimeToThink"])
            : 0
        const needTimeToThinkValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NeedTimeToThinkBudget"]
            ? parseInt(data.salceUrgeCount["NeedTimeToThinkBudget"])
            : 0
        const nonContactableCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NonContactable"]
            ? parseInt(data.salceUrgeCount["NonContactable"])
            : 0
        const nonContactableValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NonContactableBudget"]
            ? parseInt(data.salceUrgeCount["NonContactableBudget"])
            : 0
        const notInterestedAndAlreadyBookedCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NotinterestedandAlreadyBooked"]
            ? parseInt(data.salceUrgeCount["NotinterestedandAlreadyBooked"])
            : 0
        const notInterestedAndAlreadyBookedValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NotinterestedandAlreadyBookedBudget"]
            ? parseInt(
              data.salceUrgeCount["NotinterestedandAlreadyBookedBudget"]
            )
            : 0
        const notInterestedAndNotBookedCount =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NotInterestedandNotBooked"]
            ? parseInt(data.salceUrgeCount["NotInterestedandNotBooked"])
            : 0
        const notInterestedAndNotBookedValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["NotInterestedandNotBookedBudget"]
            ? parseInt(data.salceUrgeCount["NotInterestedandNotBookedBudget"])
            : 0
        const rejectedCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Rejected
            ? parseInt(data.salceUrgeCount.Rejected)
            : 0
        const rejectedValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.RejectedBudget
            ? parseInt(data.salceUrgeCount.RejectedBudget)
            : 0
        const yetCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount["YetToAction"]
            ? parseInt(data.salceUrgeCount["YetToAction"])
            : 0
        const yetValue =
          !isEmpty(data.salceUrgeCount) &&
            data.salceUrgeCount["YetToActionBudget"]
            ? parseInt(data.salceUrgeCount["YetToActionBudget"])
            : 0
        const totalCount =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Total
            ? parseInt(data.salceUrgeCount.Total)
            : 0
        const totalValue =
          !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.TotalBudget
            ? parseInt(data.salceUrgeCount.TotalBudget)
            : 0
        const salesEmployeeId = recordsMetaData && !isEmpty(recordsMetaData.employeeOptions) ?
          recordsMetaData.employeeOptions.find(m => m.name
            == data.salesAgentName) && recordsMetaData.employeeOptions.find(m => m.name
              == data.salesAgentName).value : ""
        return {
          sNo: index + 1,
          salesAgentName: data.salesAgentName ? data.salesAgentName : "--",
          branchName: data.branchName ? data.branchName : '--',
          branchId: data.branchId ? data.branchId : "--",
          Open: totalSubMode == "Count" ? openCount : openValue,
          AlmostConfirm: totalSubMode == "Count" ? almostCount : almostValue,
          Booked: totalSubMode == "Count" ? bookedCount : bookedValue,
          Followup: totalSubMode == "Count" ? followUpCount : followUpValue,
          needTime:
            totalSubMode == "Count"
              ? needTimeToThinkCount
              : needTimeToThinkValue,
          nonContact:
            totalSubMode == "Count"
              ? nonContactableCount
              : nonContactableValue,
          notInterestAlready:
            totalSubMode == "Count"
              ? notInterestedAndAlreadyBookedCount
              : notInterestedAndAlreadyBookedValue,
          notInterestNot:
            totalSubMode == "Count"
              ? notInterestedAndNotBookedCount
              : notInterestedAndNotBookedValue,
          salesEmployee: salesEmployeeId,
          yetToAction: totalSubMode == "Count" ? yetCount : yetValue,
          Rejected: totalSubMode == "Count" ? rejectedCount : rejectedValue,
          total: totalSubMode == "Count" ? totalCount : totalValue,
        }
      })
      : []
  //TAB 
  const handleSubTab = (tableData) => {

    const statusName = tableData.status
    const salesEmpId = isBranchData == false ? tableData.empId : ""
    const countDetails = {
      mode: tableData.mode,
      menuMode: tableData.menuMode,
      salesEmpId: salesEmpId
    }


    if (searchValue.visitFromDate) {
      countDetails.visitFromDate = searchValue.visitFromDate
    }
    if (searchValue.visitToDate) {
      countDetails.visitToDate = searchValue.visitToDate
    }
    if (searchValue.companyId) {
      countDetails.companyId = searchValue.companyId
    }
    if (searchValue.branchId) {
      countDetails.branchId = searchValue.branchId
    }
    if (searchValue.leadSourceId) {
      countDetails.leadSourceId = searchValue.leadSourceId
    }


   
    // Use a callback function with setStatusData to ensure statusData is updated
 
    api
    .post(`/get_client_visit_detail_report`, countDetails)
    .then((response) => {
      const statusData = !isEmpty(response.data.data) ? response.data.data : []
      setTimeout(() => {
        // Use the current value of statusData, which should be updated due to the useEffect
        console.log("statusData in setTimeout:", statusData)
        const newTab = window.open("", "_blank", "width=600,height=400")
        if (newTab) {
          const container = newTab.document.createElement("div")
          newTab.document.body.appendChild(container)
          ReactDOM.render(
            <SubTableComponent
              data={statusData} // Use statusData directly here
              dispatch={dispatch}
              statusPayload={countDetails}
              name={statusName}
              dateFormat={dateFormat}
            />,
            container
          )
          newTab.document.title = 'CLIENT-VISIT-REPORT'
        }
      }, 2000)
    })
    .catch((error) => {
      Promise.reject(error)

    })
  }
  //table columns
  const subStatusColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      footer: "",
    },
    {
      dataField: "salesAgentName",
      text: "Sales Manager",
      hidden: isBranchData == true ? true : false,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      csvExport: false,
      hidden: isBranchData == true ? false : true,
      headerStyle: {
        minWidth: "170px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "Open",
      text: "Open",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "open",
          status: "Open",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      }
      ,
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "AlmostConfirm",
      text: "Almost Confirm",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "almostConfirm",
          status: "Almost Confirm",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "Booked",
      text: "Booked",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "booked",
          status: "Booked",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "Followup",
      text: "Followup",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "followup",
          status: "Followup",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "needTime",
      text: "Need Time To Think",
      headerStyle: {
        minWidth: "180px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "needtimeToThink",
          status: "Need Time To Think",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "nonContact",
      text: "Non Contactable",
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "nonContactable",
          status: "NonContactable",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "notInterestAlready",
      text: "Not interested and Already Booked",
      headerStyle: {
        minWidth: "270px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "notInterested & alreadyBooked",
          status: "Not interested and Already Booked",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "notInterestNot",
      text: "Not interested and Not Booked",
      headerStyle: {
        minWidth: "230px",
      },

      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "notInterested & notBooked",
          status: "Not interested and Not Booked",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{
              fontWeight: 'bold', color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "Rejected",
      text: "Rejected",
      headerStyle: {
        minWidth: "200px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "Rejected",
          status: "Rejected",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "yetToAction",
      text: "Yet To Action",
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {
        const tableData = {
          mode: 3,
          menuMode: "yetToAction",
          status: "Yet To Action",
          empId: row.salesEmployee,
          branchId: row.branchId
        }
        return (
          <div
            style={{ fontWeight: 'bold' }}
            onClick={() => {
              if (isBranchData == true) {
                handleBranchTab(tableData)
              } else {
                handleSubTab(tableData)
              }
            }}
          >
            {cellContent}
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
    {
      dataField: "total",
      text: "Total",
      headerStyle: {
        minWidth: "150px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {

            const accValue = !isNaN(acc) ? acc : 0
            const itemValue = !isNaN(item) ? item : 0
            const data = parseInt(accValue + itemValue)
            return data
          }, 0)
          : 0,
    },
  ]


  //reset

  const resetForm = () => {
    setSearchInput("")
    setSalesUrgeData({
      ...salesUrgeData,
      eventFromDate: "",
      eventToDate: "",
    })
    setType({ label: "Employee", value: "employee" })
    setSearchValue({})
    setTotalMode("Values")
    setTotalProcessMode("Values")
    setTotalSubMode("Values")
    setIsBranchData(false)
    setSalesAgent([])
    setSalesProcessAgent([])
    setSalesSubAgent([])
    setCompany([])
    setBranch([])
    setSource([])
    dispatch(
      clientAcion.loadClientVisit({
        // eventFromDate: firstDayOfMonth,
        // eventToDate: lastDayOfMonth,
        mode: customIconActiveTab,
      })
    )
    setRenderPage(!renderPage)
    simpleValidator.current.hideMessages()
  }
  const clearTabs = () => {
    setSearchInput("")
    setSalesUrgeData({
      ...salesUrgeData,

      eventFromDate: "",
      eventToDate: "",
    })
    setType({ label: "Employee", value: "employee" })
    setSearchValue({})
    setTotalMode("Values")
    setTotalProcessMode("Values")
    setTotalSubMode("Values")
    setIsBranchData(false)
    setSalesAgent([])
    setSalesProcessAgent([])
    setSalesSubAgent([])
    setCompany([])
    setBranch([])
    setSource([])
    setRenderPage(!renderPage)
    simpleValidator.current.hideMessages()
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
    if (searchValue.type) {
      dispatch(
        clientAcion.loadClientVisit({
          searchFilter: searchInput,
          mode: customIconActiveTab,
        })
      )
    } else {
      dispatch(
        clientAcion.loadBranchClientVisit({
          searchFilter: searchInput,
          mode: customIconActiveTab,
        })
      )
    }
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsvOne = () => {
    var searchBranch = !isEmpty(branch) ? branches : ""
    var searchCompany = company && company.value
    var searchSource = source && source.value
    var searchFromDate =
      salesUrgeData && salesUrgeData.eventFromDate
        ? moment(salesUrgeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      salesUrgeData && salesUrgeData.eventToDate
        ? moment(salesUrgeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchSalesAgent =
      customIconActiveTab == 1
        ? salesAgents
        : customIconActiveTab == 2
          ? salesProcessAgents
          : customIconActiveTab == 3
            ? salesSubAgents
            : ""
    var searchvalue = {}
    searchvalue.mode = 1
    if (searchFromDate) {
      searchvalue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.visitToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSalesAgent) {
      searchvalue.salesAgentId = searchSalesAgent
    }
    var branchSearchValue = {}
    branchSearchValue.mode = 1
    if (searchFromDate) {
      branchSearchValue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      branchSearchValue.visitToDate = searchToDate
    }
    if (searchBranch) {
      branchSearchValue.branchId = searchBranch
    }
    if (searchCompany) {
      branchSearchValue.companyId = searchCompany
    }
    if (searchSource) {
      branchSearchValue.leadSourceId = searchSource
    }
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)
    const url = isBranchData == true ? `/get_client_visit_report_branch` : `/get_client_visit_report`
    const payload = isBranchData == true ? branchSearchValue : searchvalue
    api
      .post(url, payload)
      .then((response) => {
        const salesExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const hotCount =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.Hot
                ? parseInt(data.salesUrgeCount.Hot)
                : 0
            const hotValue =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.HotBudget
                ? parseInt(data.salesUrgeCount.HotBudget)
                : 0

            const warmCount =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.Warm
                ? parseInt(data.salesUrgeCount.Warm)
                : 0
            const warmValue =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.WarmBudget
                ? parseInt(data.salesUrgeCount.WarmBudget)
                : 0

            const coldCount =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.Cold
                ? parseInt(data.salesUrgeCount.Cold)
                : 0
            const coldValue =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.ColdBudget
                ? parseInt(data.salesUrgeCount.ColdBudget)
                : 0

            const totalCount =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.Total
                ? parseInt(data.salesUrgeCount.Total)
                : 0
            const totalValue =
              !isEmpty(data.salesUrgeCount) && data.salesUrgeCount.TotalBudget
                ? parseInt(data.salesUrgeCount.TotalBudget)
                : 0
            return {
              sNo: index + 1,
              salesAgentName: data.salesAgentName ? data.salesAgentName : 0,
              branchName: data.branchName ? data.branchName : "--",
              hot: totalMode == "Count" ? hotCount : hotValue,
              warm: totalMode == "Count" ? warmCount : warmValue,
              cold: totalMode == "Count" ? coldCount : coldValue,
              total: totalMode == "Count" ? totalCount : totalValue,
            }
          })
          : []

        setTimeout(() => {
          let headerData = [`S.No,${isBranchData == true ? "Branch Name" : "Sales Agent Name"},Sales Agent Name,Hot,Warm,Cold,Total`]

          let usersCsv = salesExportDataTable.reduce((acc, user) => {
            if (isBranchData == false) {
              const { sNo, salesAgentName, hot, warm, cold, total } = user
              acc.push([sNo, salesAgentName, hot, warm, cold, total])
            }
            else {
              const { sNo, branchName, hot, warm, cold, total } = user
              acc.push([sNo, branchName, hot, warm, cold, total])
            }

            return acc
          }, [])

          const columnTotals = salesExportDataTable.reduce(
            (totals, user) => {
              totals[2] += user.hot
              totals[3] += user.warm
              totals[4] += user.cold
              totals[5] += user.total
              return totals
            },
            ["", "Total", 0, 0, 0, 0] // Initial values for S.No and Sales Agent Name
          )
          usersCsv.push(columnTotals)
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ClientVisitReportSalesUrge.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  const exportToCsvTwo = () => {
    var searchBranch = !isEmpty(branch) ? branches : ""
    var searchCompany = company && company.value
    var searchSource = source && source.value
    var searchFromDate =
      salesUrgeData && salesUrgeData.eventFromDate
        ? moment(salesUrgeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      salesUrgeData && salesUrgeData.eventToDate
        ? moment(salesUrgeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchSalesAgent =
      customIconActiveTab == 1
        ? salesAgents
        : customIconActiveTab == 2
          ? salesProcessAgents
          : customIconActiveTab == 3
            ? salesSubAgents
            : ""
    var searchvalue = {}
    searchvalue.mode = 2
    if (searchFromDate) {
      searchvalue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.visitToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSalesAgent) {
      searchvalue.salesAgentId = searchSalesAgent
    }
    var branchSearchValue = {}
    branchSearchValue.mode = 2
    if (searchFromDate) {
      branchSearchValue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      branchSearchValue.visitToDate = searchToDate
    }
    if (searchBranch) {
      branchSearchValue.branchId = searchBranch
    }
    if (searchCompany) {
      branchSearchValue.companyId = searchCompany
    }
    if (searchSource) {
      branchSearchValue.leadSourceId = searchSource
    }
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)
    const url = isBranchData == true ? `/get_client_visit_report_branch` : `/get_client_visit_report`
    const payload = isBranchData == true ? branchSearchValue : searchvalue
    api
      .post(url, payload)
      .then((response) => {
        const processExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const assignedCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Assigned
                ? parseInt(data.salceUrgeCount.Assigned)
                : 0
            const assignedValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AssignedBudget
                ? parseInt(data.salceUrgeCount.AssignedBudget)
                : 0

            const followUpCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Followup
                ? parseInt(data.salceUrgeCount.Followup)
                : 0
            const followUpValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.FollowupBudget
                ? parseInt(data.salceUrgeCount.FollowupBudget)
                : 0
            const QuotationCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QuotationCreated
                ? parseInt(data.salceUrgeCount.QuotationCreated)
                : 0
            const QuotationValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QuotationCreatedBudget
                ? parseInt(data.salceUrgeCount.QuotationCreatedBudget)
                : 0

            const QuoteSendCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.QuoteSent
                ? parseInt(data.salceUrgeCount.QuoteSent)
                : 0
            const QuoteSentValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QuoteSentBudget
                ? parseInt(data.salceUrgeCount.QuoteSentBudget)
                : 0
            const qcSentCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcRequestSent
                ? parseInt(data.salceUrgeCount.QcRequestSent)
                : 0
            const qcSentValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcRequestSentBudget
                ? parseInt(data.salceUrgeCount.QcRequestSentBudget)
                : 0

            const qcApproveCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcApproveQuote
                ? parseInt(data.salceUrgeCount.QcApproveQuote)
                : 0
            const qcApproveValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcApproveQuoteBudget
                ? parseInt(data.salceUrgeCount.QcApproveQuoteBudget)
                : 0

            const qcRecheckCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcRecheckQuote
                ? parseInt(data.salceUrgeCount.QcRecheckQuote)
                : 0
            const qcRecheckValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.QcRecheckQuoteBudget
                ? parseInt(data.salceUrgeCount.QcRecheckQuoteBudget)
                : 0
            const bookingCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.BookingComplete
                ? parseInt(data.salceUrgeCount.BookingComplete)
                : 0
            const bookingValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.BookingCompleteBudget
                ? parseInt(data.salceUrgeCount.BookingCompleteBudget)
                : 0

            const rejectedCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Rejected
                ? parseInt(data.salceUrgeCount.Rejected)
                : 0
            const rejectedValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.RejectedBudget
                ? parseInt(data.salceUrgeCount.RejectedBudget)
                : 0

            const requestForCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.RequestForQuoteAlteration
                ? parseInt(data.salceUrgeCount.RequestForQuoteAlteration)
                : 0
            const requestForValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.RequestForQuoteAlterationBudget
                ? parseInt(
                  data.salceUrgeCount.RequestForQuoteAlterationBudget
                )
                : 0
            const quoteApproachCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AlterQuoteApproach
                ? parseInt(data.salceUrgeCount.AlterQuoteApproach)
                : 0
            const quoteApproachValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AlterQuoteApproachBudget
                ? parseInt(data.salceUrgeCount.AlterQuoteApproachBudget)
                : 0

            const quoteRecheckCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AlterQuoteRecheck
                ? parseInt(data.salceUrgeCount.AlterQuoteRecheck)
                : 0
            const quoteRecheckValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AlterQuoteRecheckBudget
                ? parseInt(data.salceUrgeCount.AlterQuoteRecheckBudget)
                : 0
            const totalCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Total
                ? parseInt(data.salceUrgeCount.Total)
                : 0
            const totalValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.TotalBudget
                ? parseInt(data.salceUrgeCount.TotalBudget)
                : 0
            return {
              key: index,
              sNo: index + 1,
              salesAgentName: data.salesAgentName
                ? data.salesAgentName
                : "--",
              branchName: data.branchName ? data.branchName : "--",
              assigned:
                totalProcessMode == "Count" ? assignedCount : assignedValue,
              followUp:
                totalProcessMode == "Count" ? followUpCount : followUpValue,
              QuotationCreated:
                totalProcessMode == "Count" ? QuotationCount : QuotationValue,
              QuoteSent:
                totalProcessMode == "Count" ? QuoteSendCount : QuoteSentValue,
              QcRequestSent:
                totalProcessMode == "Count" ? qcSentCount : qcSentValue,
              QcApproveQuote:
                totalProcessMode == "Count" ? qcApproveCount : qcApproveValue,
              QcRecheckQuote:
                totalProcessMode == "Count" ? qcRecheckCount : qcRecheckValue,
              BookingComplete:
                totalProcessMode == "Count" ? bookingCount : bookingValue,
              Rejected:
                totalProcessMode == "Count" ? rejectedCount : rejectedValue,
              RequestForQuoteAlteration:
                totalProcessMode == "Count"
                  ? requestForCount
                  : requestForValue,
              AlterQuoteApproach:
                totalProcessMode == "Count"
                  ? quoteApproachCount
                  : quoteApproachValue,
              AlterQuoteRecheck:
                totalProcessMode == "Count"
                  ? quoteRecheckCount
                  : quoteRecheckValue,
              total: totalMode == "Count" ? totalCount : totalValue,
            }
          })
          : []

        setTimeout(() => {
          let headerData = [
            `S.No,${isBranchData == true ? "Branch Name" : "Sales Agent Name"},Assigned,Followup,Quotation Created / Quote Sent,Qc Request Sent,Qc Approve Quote,Qc  Recheck Quote,Booking Complete,Rejected,Request For Quote Alteration,Alter Quote Approach,Alter Quote Recheck,Total`
          ]
          const columnTotalsEmployee = processExportDataTable.reduce(
            (totals, user) => {
              totals.assigned += user.assigned
              totals.followUp += user.followUp
              totals.QuotationCreated += user.QuotationCreated
              totals.QcRequestSent += user.QcRequestSent
              totals.QcApproveQuote += user.QcApproveQuote
              totals.QcRecheckQuote += user.QcRecheckQuote
              totals.BookingComplete += user.BookingComplete
              totals.Rejected += user.Rejected
              totals.RequestForQuoteAlteration += user.RequestForQuoteAlteration
              totals.AlterQuoteApproach += user.AlterQuoteApproach
              totals.AlterQuoteRecheck += user.AlterQuoteRecheck
              totals.total += user.total
              return totals
            },
            {
              sNo: "",
              salesAgentName: "Total", // Assuming empty string for salesAgentName
              assigned: 0,
              followUp: 0,
              QuotationCreated: 0,
              QcRequestSent: 0,
              QcApproveQuote: 0,
              QcRecheckQuote: 0,
              BookingComplete: 0,
              Rejected: 0,
              RequestForQuoteAlteration: 0,
              AlterQuoteApproach: 0,
              AlterQuoteRecheck: 0,
              total: 0,
            }
          )
          const columnTotalsBranch = processExportDataTable.reduce(
            (totals, user) => {
              totals.assigned += user.assigned
              totals.followUp += user.followUp
              totals.QuotationCreated += user.QuotationCreated
              totals.QcRequestSent += user.QcRequestSent
              totals.QcApproveQuote += user.QcApproveQuote
              totals.QcRecheckQuote += user.QcRecheckQuote
              totals.BookingComplete += user.BookingComplete
              totals.Rejected += user.Rejected
              totals.RequestForQuoteAlteration += user.RequestForQuoteAlteration
              totals.AlterQuoteApproach += user.AlterQuoteApproach
              totals.AlterQuoteRecheck += user.AlterQuoteRecheck
              totals.total += user.total
              return totals
            },
            {
              sNo: "",
              branchName: "Total", // Assuming empty string for salesAgentName
              assigned: 0,
              followUp: 0,
              QuotationCreated: 0,
              QcRequestSent: 0,
              QcApproveQuote: 0,
              QcRecheckQuote: 0,
              BookingComplete: 0,
              Rejected: 0,
              RequestForQuoteAlteration: 0,
              AlterQuoteApproach: 0,
              AlterQuoteRecheck: 0,
              total: 0,
            }
          )
          const columnTotals = isBranchData == true ? columnTotalsBranch : columnTotalsEmployee
          processExportDataTable.push(columnTotals)
          let usersCsv = processExportDataTable.reduce((acc, user) => {
            if (isBranchData == false) {
              const {
                sNo,
                salesAgentName,
                assigned,
                followUp,
                QuotationCreated,
                QcRequestSent,
                QcApproveQuote,
                QcRecheckQuote,
                BookingComplete,
                Rejected,
                RequestForQuoteAlteration,
                AlterQuoteApproach,
                AlterQuoteRecheck,
                total,
              } = user
              acc.push([
                sNo,
                salesAgentName,
                assigned,
                followUp,
                QuotationCreated,
                QcRequestSent,
                QcApproveQuote,
                QcRecheckQuote,
                BookingComplete,
                Rejected,
                RequestForQuoteAlteration,
                AlterQuoteApproach,
                AlterQuoteRecheck,
                total,
              ])
            }
            else {
              const {
                sNo,
                branchName,
                assigned,
                followUp,
                QuotationCreated,
                QcRequestSent,
                QcApproveQuote,
                QcRecheckQuote,
                BookingComplete,
                Rejected,
                RequestForQuoteAlteration,
                AlterQuoteApproach,
                AlterQuoteRecheck,
                total,
              } = user
              acc.push([
                sNo,
                branchName,
                assigned,
                followUp,
                QuotationCreated,
                QcRequestSent,
                QcApproveQuote,
                QcRecheckQuote,
                BookingComplete,
                Rejected,
                RequestForQuoteAlteration,
                AlterQuoteApproach,
                AlterQuoteRecheck,
                total,
              ])
            }

            return acc
          }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ClientVisitReportProcessStatus.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  const exportToCsvThree = () => {
    var searchBranch = !isEmpty(branch) ? branches : ""
    var searchCompany = company && company.value
    var searchSource = source && source.value
    var searchFromDate =
      salesUrgeData && salesUrgeData.eventFromDate
        ? moment(salesUrgeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      salesUrgeData && salesUrgeData.eventToDate
        ? moment(salesUrgeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchSalesAgent =
      customIconActiveTab == 1
        ? salesAgents
        : customIconActiveTab == 2
          ? salesProcessAgents
          : customIconActiveTab == 3
            ? salesSubAgents
            : ""
    var searchvalue = {}
    searchvalue.mode = 3
    if (searchFromDate) {
      searchvalue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.visitToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSalesAgent) {
      searchvalue.salesAgentId = searchSalesAgent
    }
    var branchSearchValue = {}
    branchSearchValue.mode = 3
    if (searchFromDate) {
      branchSearchValue.visitFromDate = searchFromDate
    }
    if (searchToDate) {
      branchSearchValue.visitToDate = searchToDate
    }
    if (searchBranch) {
      branchSearchValue.branchId = searchBranch
    }
    if (searchCompany) {
      branchSearchValue.companyId = searchCompany
    }
    if (searchSource) {
      branchSearchValue.leadSourceId = searchSource
    }
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)
    const url = isBranchData == true ? `/get_client_visit_report_branch` : `/get_client_visit_report`
    const payload = isBranchData == true ? branchSearchValue : searchvalue
    api
      .post(url, payload)
      .then((response) => {
        const subExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const openCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Open
                ? parseInt(data.salceUrgeCount.Open)
                : 0
            const openValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.OpenBudget
                ? parseInt(data.salceUrgeCount.OpenBudget)
                : 0
            const almostCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.AlmostConfirm
                ? parseInt(data.salceUrgeCount.AlmostConfirm)
                : 0
            const almostValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount.AlmostConfirmBudget
                ? parseInt(data.salceUrgeCount.AlmostConfirmBudget)
                : 0

            const bookedCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Booked
                ? parseInt(data.salceUrgeCount.Booked)
                : 0
            const bookedValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.BookedBudget
                ? parseInt(data.salceUrgeCount.BookedBudget)
                : 0
            const followUpCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Followup
                ? parseInt(data.salceUrgeCount.Followup)
                : 0
            const followUpValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.FollowupBudget
                ? parseInt(data.salceUrgeCount.FollowupBudget)
                : 0
            const needTimeToThinkCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NeedTimeToThink"]
                ? parseInt(data.salceUrgeCount["NeedTimeToThink"])
                : 0
            const needTimeToThinkValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NeedTimeToThinkBudget"]
                ? parseInt(data.salceUrgeCount["NeedTimeToThinkBudget"])
                : 0
            const nonContactableCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NonContactable"]
                ? parseInt(data.salceUrgeCount["NonContactable"])
                : 0
            const nonContactableValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NonContactableBudget"]
                ? parseInt(data.salceUrgeCount["NonContactableBudget"])
                : 0
            const notInterestedAndAlreadyBookedCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NotinterestedandAlreadyBooked"]
                ? parseInt(data.salceUrgeCount["NotinterestedandAlreadyBooked"])
                : 0
            const notInterestedAndAlreadyBookedValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NotinterestedandAlreadyBookedBudget"]
                ? parseInt(
                  data.salceUrgeCount["NotinterestedandAlreadyBookedBudget"]
                )
                : 0
            const notInterestedAndNotBookedCount =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NotInterestedandNotBooked"]
                ? parseInt(data.salceUrgeCount["NotInterestedandNotBooked"])
                : 0
            const notInterestedAndNotBookedValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["NotInterestedandNotBookedBudget"]
                ? parseInt(data.salceUrgeCount["NotInterestedandNotBookedBudget"])
                : 0
            const rejectedCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Rejected
                ? parseInt(data.salceUrgeCount.Rejected)
                : 0
            const rejectedValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.RejectedBudget
                ? parseInt(data.salceUrgeCount.RejectedBudget)
                : 0
            const yetCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount["YetToAction"]
                ? parseInt(data.salceUrgeCount["YetToAction"])
                : 0
            const yetValue =
              !isEmpty(data.salceUrgeCount) &&
                data.salceUrgeCount["YetToActionBudget"]
                ? parseInt(data.salceUrgeCount["YetToActionBudget"])
                : 0
            const totalCount =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.Total
                ? parseInt(data.salceUrgeCount.Total)
                : 0
            const totalValue =
              !isEmpty(data.salceUrgeCount) && data.salceUrgeCount.TotalBudget
                ? parseInt(data.salceUrgeCount.TotalBudget)
                : 0
            return {
              sNo: index + 1,
              salesAgentName: data.salesAgentName
                ? data.salesAgentName
                : "--",
              branchName: data.branchName ? data.branchName : "--",
              Open: totalSubMode == "Count" ? openCount : openValue,
              AlmostConfirm:
                totalSubMode == "Count" ? almostCount : almostValue,
              Booked: totalSubMode == "Count" ? bookedCount : bookedValue,
              Followup:
                totalSubMode == "Count" ? followUpCount : followUpValue,
              needTime:
                totalSubMode == "Count"
                  ? needTimeToThinkCount
                  : needTimeToThinkValue,
              nonContact:
                totalSubMode == "Count"
                  ? nonContactableCount
                  : nonContactableValue,
              notInterestAlready:
                totalSubMode == "Count"
                  ? notInterestedAndAlreadyBookedCount
                  : notInterestedAndAlreadyBookedValue,
              notInterestNot:
                totalSubMode == "Count"
                  ? notInterestedAndNotBookedCount
                  : notInterestedAndNotBookedValue,
              yetToAction: totalSubMode == "Count" ? yetCount : yetValue,
              Rejected:
                totalSubMode == "Count" ? rejectedCount : rejectedValue,
              total: totalSubMode == "Count" ? totalCount : totalValue,
            }
          })
          : []

        setTimeout(() => {
          let headerData = [
            "S.No,Sales Agent Name,Open,Almost Confirm,Booked,Followup,Need Time To Think,Non Contactable,Not interested and Already Booked,Not interested and Not Booked,Rejected,Yet To Action,Total",
          ]
          const columnTotals = subExportDataTable.reduce(
            (totals, user) => {
              totals.Open += user.Open
              totals.AlmostConfirm += user.AlmostConfirm
              totals.Booked += user.Booked
              totals.Followup += user.Followup
              totals.needTime += user.needTime
              totals.nonContact += user.nonContact
              totals.notInterestAlready += user.notInterestAlready
              totals.notInterestNot += user.notInterestNot
              totals.Rejected += user.Rejected
              totals.yetToAction += user.yetToAction
              totals.total += user.total
              return totals
            },
            {
              sNo: "",
              salesAgentName: "Total", // Assuming empty string for salesAgentName
              Open: 0,
              AlmostConfirm: 0,
              Booked: 0,
              Followup: 0,
              needTime: 0,
              nonContact: 0,
              notInterestAlready: 0,
              notInterestNot: 0,
              Rejected: 0,
              yetToAction: 0,
              total: 0,
            }
          )

          subExportDataTable.push(columnTotals)
          let usersCsv = subExportDataTable.reduce((acc, user) => {
            const {
              sNo,
              salesAgentName,
              Open,
              AlmostConfirm,
              Booked,
              Followup,
              needTime,
              nonContact,
              notInterestAlready,
              notInterestNot,
              Rejected,
              yetToAction,
              total,
            } = user
            acc.push([
              sNo,
              salesAgentName,
              Open,
              AlmostConfirm,
              Booked,
              Followup,
              needTime,
              nonContact,
              notInterestAlready,
              notInterestNot,
              Rejected,
              yetToAction,
              total,
            ])

            return acc
          }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ClientVisitReportSubStatus.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  const options = {
    sizePerPage: 50,
    totalSize: client_data.length,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Sales"} breadcrumbItem={title} />
        <Row>
          <Col className=" mb-4">
            <Nav className="nav-tabs-custom nav-justified mx-auto w-50 ">
              {(tabs || []).map((tab, tabIndex) => {
                // border: "1px solid #c7c7c7"
                return (
                  <NavItem key={tabIndex}>
                    <NavLink
                      style={
                        tab && customIconActiveTab !== tab.id
                          ? {
                            cursor: "pointer",
                            color: "#000000",
                            border: "1px solid #c7c7c7",
                            backgroundColor: "#e4e4e4",
                          }
                          : {
                            cursor: "pointer",
                            color: "#ffffff",
                            border: "1px solid #c7c7c7",
                            backgroundColor: "#e40d8c",
                          }
                      }
                      onClick={() => {
                        setCustomIconActiveTab(tab && tab.id)
                        clearTabs()
                        dispatch(clientAcion.loadClientVisit({ mode: tab.id }))
                      }}
                    >
                      <span
                        // className="tabs-content d-none d-sm-block"
                        style={{ display: "inline-block", textAlign: "center" }}
                      >
                        {tab.label}
                      </span>
                    </NavLink>
                  </NavItem>
                )
              })}
            </Nav>
          </Col>

          {customIconActiveTab === 1 && (
            <div>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Company</Label>

                        <Select
                          type="text"
                          name="company"
                          value={company}
                          onChange={(e) => handleCompany(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message('Company', company, 'required')}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Branch</Label>
                        <MultiSelect
                          options={branchListOptions}
                          value={branch}
                          onChange={setBranch}
                          labelledBy="Select"
                          hasSelectAll={true}
                        />

                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-3"
                      >
                        <Label className="employee-label">Lead Source</Label>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          onChange={(e) => setSource(e)}
                          options={
                            recordsMetaData ? recordsMetaData.sourceOptions : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit From Date"}
                          >
                            {"Visit From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventFromDate"
                          value={salesUrgeData.eventFromDate}
                          max={salesUrgeData.eventToDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit To Date"}
                          >
                            {"Visit To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventToDate"
                          value={salesUrgeData.eventToDate}
                          min={salesUrgeData.eventFromDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Sales Agent</Label>
                        <Select
                          type="text"
                          isMulti
                          name="salesAgent"
                          value={salesAgent}
                          onChange={(e) => setSalesAgent(e)}
                          options={
                            !isEmpty(recordsMetaData)
                              ? recordsMetaData.employeeOptions
                              : []
                          }
                          placeholder="Select Sales Agent"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Type</Label>
                        <Select
                          type="text"
                          name="type"
                          value={type}
                          onChange={(e) => setType(e)}
                          options={[{ label: "Employee", value: "employee" },
                          { label: "Branch", value: "branch" }]}
                          placeholder="Select Type"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                            onClick={() => {
                              resetForm()
                            }}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>

              <Row className="mt-3">
                <Col md="12" lg="12" xl="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <div
                            className="switch-field"
                            style={{ float: "right", marginBottom: "-2px" }}
                          >
                            <button
                              style={{
                                backgroundColor:
                                  valueData == true ? "#e40d8c" : "#e4e4e4",
                                boxShadow:
                                  valueData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  valueData == true ? "#ffffff" : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "4px",
                              }}
                              onClick={() => {
                                setCounterData(false)
                                setValueData(true)
                                setTotalMode("Values")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Values
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  counterData == true ? "#e40d8c" : "#e4e4e4",
                                boxShadow:
                                  counterData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  counterData == true ? "#ffffff" : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "2px",
                              }}
                              onClick={() => {
                                setValueData(false)
                                setCounterData(true)
                                setTotalMode("Count")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Count
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <Col md="4">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <form
                              onSubmit={handleClick}
                              className="d-flex flex-row"
                            >
                              <div style={searchBtnStyle || null}>
                                <Input
                                  type="text"
                                  name="searchInput"
                                  value={searchInput}
                                  onChange={(e) =>
                                    setSearchInput(e.target.value)
                                  }
                                  className="form-control"
                                  placeholder="Search"
                                  style={{ position: "relative" }}
                                />
                                <i
                                  className="bx bx-search-alt"
                                  style={{
                                    position: "absolute",
                                    top: "13px",
                                    left: "30px",
                                    fontSize: "13px",
                                  }}
                                />
                              </div>
                              <button
                                className="btn btn-success mx-2"
                                type="submit"
                                style={{
                                  background: searchFilter ? "#2ca67a" : "",
                                  color: searchFilter ? "#ffffff" : "",
                                }}
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </Col>
                        <Col md="8" style={{ marginBottom: "20px" }}>
                          <div
                            style={{
                              float: "right",
                              marginRight: "10px",
                            }}
                          >
                            <Button
                              className="btn btn-primary"
                              onClick={exportToCsvOne}
                              id="download"
                              style={{
                                backgroundColor: "#e40d8c",
                                color: "white",
                                border: "none",
                              }}
                            >
                              Download
                            </Button>
                          </div>
                        </Col>
                      </Row>{" "}
                      <Col md="12" lg="12" xl="12" className="mt-3">
                        <PaginationProvider
                          pagination={paginationFactory(options)}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col
                                    style={{ overflowX: "auto", width: "100%" }}
                                  >
                                    <BootstrapTable
                                      data={salesUrgeTable}
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={columns}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </PaginationProvider>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
          {customIconActiveTab === 2 && (
            <div>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Company</Label>

                        <Select
                          type="text"
                          name="company"
                          value={company}
                          onChange={(e) => handleCompany(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message('Company', company, 'required')}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Branch</Label>
                        <MultiSelect
                          options={branchListOptions}
                          value={branch}
                          onChange={setBranch}
                          labelledBy="Select"
                          hasSelectAll={true}
                        />

                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-3"
                      >
                        <Label className="employee-label">Lead Source</Label>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          onChange={(e) => setSource(e)}
                          options={
                            recordsMetaData ? recordsMetaData.sourceOptions : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit From Date"}
                          >
                            {"Visit From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventFromDate"
                          value={salesUrgeData.eventFromDate}
                          max={salesUrgeData.eventToDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit To Date"}
                          >
                            {"Visit To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventToDate"
                          value={salesUrgeData.eventToDate}
                          min={salesUrgeData.eventFromDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Sales Agent</Label>
                        <Select
                          type="text"
                          isMulti
                          name="salesProcessAgent"
                          value={salesProcessAgent}
                          onChange={(e) => setSalesProcessAgent(e)}
                          options={
                            !isEmpty(recordsMetaData)
                              ? recordsMetaData.employeeOptions
                              : []
                          }
                          placeholder="Select Sales Agent"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Type</Label>
                        <Select
                          type="text"
                          name="type"
                          value={type}
                          onChange={(e) => setType(e)}
                          options={[{ label: "Employee", value: "employee" },
                          { label: "Branch", value: "branch" }]}
                          placeholder="Select Type"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                            onClick={() => {
                              resetForm()
                            }}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
              <Row className="mt-3">
                <Col md="12" lg="12" xl="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <div
                            className="switch-field"
                            style={{ float: "right", marginBottom: "-2px" }}
                          >
                            <button
                              style={{
                                backgroundColor:
                                  valueProcessData == true
                                    ? "#e40d8c"
                                    : "#e4e4e4",
                                boxShadow:
                                  valueProcessData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  valueProcessData == true
                                    ? "#ffffff"
                                    : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "4px",
                              }}
                              onClick={() => {
                                setCounterProcessData(false)
                                setValueProcessData(true)
                                setTotalProcessMode("Values")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Values
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  counterProcessData == true
                                    ? "#e40d8c"
                                    : "#e4e4e4",
                                boxShadow:
                                  counterProcessData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  counterProcessData == true
                                    ? "#ffffff"
                                    : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "2px",
                              }}
                              onClick={() => {
                                setValueProcessData(false)
                                setCounterProcessData(true)
                                setTotalProcessMode("Count")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Count
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <Col md="4">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <form
                              onSubmit={handleClick}
                              className="d-flex flex-row"
                            >
                              <div style={searchBtnStyle || null}>
                                <Input
                                  type="text"
                                  name="searchInput"
                                  value={searchInput}
                                  onChange={(e) =>
                                    setSearchInput(e.target.value)
                                  }
                                  className="form-control"
                                  placeholder="Search"
                                  style={{ position: "relative" }}
                                />
                                <i
                                  className="bx bx-search-alt"
                                  style={{
                                    position: "absolute",
                                    top: "13px",
                                    left: "30px",
                                    fontSize: "13px",
                                  }}
                                />
                              </div>
                              <button
                                className="btn btn-success mx-2"
                                type="submit"
                                style={{
                                  background: searchFilter ? "#2ca67a" : "",
                                  color: searchFilter ? "#ffffff" : "",
                                }}
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </Col>
                        <Col md="8" style={{ marginBottom: "20px" }}>
                          <div
                            style={{
                              float: "right",
                              marginRight: "10px",
                            }}
                          >
                            <Button
                              className="btn btn-primary"
                              onClick={exportToCsvTwo}
                              id="download"
                              style={{
                                backgroundColor: "#e40d8c",
                                color: "white",
                                border: "none",
                              }}
                            >
                              Download
                            </Button>
                          </div>
                        </Col>
                      </Row>{" "}
                      <Col md="12" lg="12" xl="12" className="mt-3">
                        <PaginationProvider
                          pagination={paginationFactory(options)}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col
                                    style={{ overflowX: "auto", width: "100%" }}
                                  >
                                    <BootstrapTable
                                      data={processStatusTable}
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={processColumns}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </PaginationProvider>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
          {customIconActiveTab === 3 && (
            <div>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Company</Label>

                        <Select
                          type="text"
                          name="company"
                          value={company}
                          onChange={(e) => handleCompany(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message('Company', company, 'required')}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Branch</Label>
                        <MultiSelect
                          options={branchListOptions}
                          value={branch}
                          onChange={setBranch}
                          labelledBy="Select"
                          hasSelectAll={true}
                        />

                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-3"
                      >
                        <Label className="employee-label">Lead Source</Label>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          onChange={(e) => setSource(e)}
                          options={
                            recordsMetaData ? recordsMetaData.sourceOptions : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit From Date"}
                          >
                            {"Visit From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventFromDate"
                          value={salesUrgeData.eventFromDate}
                          max={salesUrgeData.eventToDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Visit To Date"}
                          >
                            {"Visit To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventToDate"
                          value={salesUrgeData.eventToDate}
                          min={salesUrgeData.eventFromDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter "
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Sales Agent</Label>
                        <Select
                          type="text"
                          isMulti
                          name="salesSubAgent"
                          value={salesSubAgent}
                          onChange={(e) => setSalesSubAgent(e)}
                          options={
                            !isEmpty(recordsMetaData)
                              ? recordsMetaData.employeeOptions
                              : []
                          }
                          placeholder="Select Sales Agent"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="employee-label">Type</Label>
                        <Select
                          type="text"
                          name="type"
                          value={type}
                          onChange={(e) => setType(e)}
                          options={[{ label: "Employee", value: "employee" },
                          { label: "Branch", value: "branch" }]}
                          placeholder="Select Type"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                            onClick={() => {
                              resetForm()
                            }}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
              <Row className="mt-3">
                <Col md="12" lg="12" xl="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <div
                            className="switch-field"
                            style={{ float: "right", marginBottom: "-2px" }}
                          >
                            <button
                              style={{
                                backgroundColor:
                                  valueSubData == true ? "#e40d8c" : "#e4e4e4",
                                boxShadow:
                                  valueSubData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  valueSubData == true ? "#ffffff" : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "4px",
                              }}
                              onClick={() => {
                                setCounterSubData(false)
                                setValueSubData(true)
                                setTotalSubMode("Values")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Values
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  counterSubData == true
                                    ? "#e40d8c"
                                    : "#e4e4e4",
                                boxShadow:
                                  counterSubData == true
                                    ? "none"
                                    : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                                color:
                                  counterSubData == true
                                    ? "#ffffff"
                                    : "#000000",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px 12px",
                                // borderRadius: "2px",
                              }}
                              onClick={() => {
                                setValueSubData(false)
                                setCounterSubData(true)
                                setTotalSubMode("Count")
                                setLoading(true)
                                setTimeout(() => {
                                  setLoading(false)
                                }, 500)
                              }}
                            >
                              Count
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <Col md="4">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <form
                              onSubmit={handleClick}
                              className="d-flex flex-row"
                            >
                              <div style={searchBtnStyle || null}>
                                <Input
                                  type="text"
                                  name="searchInput"
                                  value={searchInput}
                                  onChange={(e) =>
                                    setSearchInput(e.target.value)
                                  }
                                  className="form-control"
                                  placeholder="Search"
                                  style={{ position: "relative" }}
                                />
                                <i
                                  className="bx bx-search-alt"
                                  style={{
                                    position: "absolute",
                                    top: "13px",
                                    left: "30px",
                                    fontSize: "13px",
                                  }}
                                />
                              </div>
                              <button
                                className="btn btn-success mx-2"
                                type="submit"
                                style={{
                                  background: searchFilter ? "#2ca67a" : "",
                                  color: searchFilter ? "#ffffff" : "",
                                }}
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </Col>
                        <Col md="8" style={{ marginBottom: "20px" }}>
                          <div
                            style={{
                              float: "right",
                              marginRight: "10px",
                            }}
                          >
                            <Button
                              className="btn btn-primary"
                              onClick={exportToCsvThree}
                              id="download"
                              style={{
                                backgroundColor: "#e40d8c",
                                color: "white",
                                border: "none",
                              }}
                            >
                              Download
                            </Button>
                          </div>
                        </Col>
                      </Row>{" "}
                      <Col md="12" lg="12" xl="12" className="mt-3">
                        <PaginationProvider
                          pagination={paginationFactory(options)}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col
                                    style={{ overflowX: "auto", width: "100%" }}
                                  >
                                    <BootstrapTable
                                      data={subStatusTable}
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={subStatusColumns}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </PaginationProvider>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
          {loading ? (
            <Modal show={loading} style={{ width: "6.8%", margin: "18% 50%" }}>
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "6.8%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Row>
      </Container>
    </div>
  )
}
ClientVisitReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
  baseProps: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientVisitReport)
)
